import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClear = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	enableBackground: "new 0 0 24 24",
	height: 512,
	viewBox: "0 0 24 24",
	width: 512,
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "m21.25 0h-18.5c-1.517 0-2.75 1.233-2.75 2.75v18.5c0 1.517 1.233 2.75 2.75 2.75h18.5c1.517 0 2.75-1.233 2.75-2.75v-18.5c0-1.517-1.233-2.75-2.75-2.75zm-1.25 16.25c0 .965-.785 1.75-1.75 1.75h-8.5c-.205 0-.401-.084-.543-.232l-5-5.25c-.276-.29-.276-.745 0-1.035l5-5.25c.142-.149.338-.233.543-.233h8.5c.965 0 1.75.785 1.75 1.75z" }),
		/* @__PURE__ */ _jsx("path", { d: "m16.5 15c-.256 0-.512-.098-.707-.293l-4-4c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0l4 4c.391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293z" }),
		/* @__PURE__ */ _jsx("path", { d: "m12.5 15c-.256 0-.512-.098-.707-.293-.391-.391-.391-1.023 0-1.414l4-4c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414l-4 4c-.195.195-.451.293-.707.293z" })
	]
});
const ForwardRef = forwardRef(SvgClear);
export { ForwardRef as ReactComponent };
